"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var chart_1 = require("../types/chart");
exports.default = (_a = {},
    _a[chart_1.Type.Bar] = {
        // 跟图表有关的配置都要写到config中
        config: {}
    },
    _a[chart_1.Type.Line] = {
        config: {
            title: {
                text: "",
                x: "center",
                y: "5%",
                textStyle: {
                    color: "#788492",
                    fontSize: "14px",
                    fontWeight: "normal"
                }
            },
            tooltip: {
                trigger: "axis"
            },
            legend: {
                top: "0%",
                left: "right",
                itemWidth: 6,
                itemHeight: 6,
                textStyle: {
                    color: "#778493"
                }
            },
            grid: {
                top: "18%",
                bottom: "15%",
                left: "10%"
            }
        }
    },
    _a[chart_1.Type.Map] = {},
    _a[chart_1.Type.Pie] = {},
    _a[chart_1.Type.Scatter] = {},
    _a[chart_1.Type.Radar] = {
        config: {
            legend: {
                top: "0%",
                left: "right",
                itemWidth: 6,
                itemHeight: 6,
                itemGap: 30,
                icon: "circle",
                textStyle: {
                    color: "#778493"
                }
            },
            radar: {
                name: {
                    color: "#A9B0B9"
                },
                axisLine: {
                    lineStyle: {
                        color: "#E2E8F2"
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: ["#E2E8F2"]
                    }
                },
                splitArea: {
                    areaStyle: {
                        color: ["rgba(225, 231, 241, 0.1)"]
                    }
                }
            }
        }
    },
    _a[chart_1.Type.Gauge] = {
        config: {
            tooltip: {
                formatter: "{a} <br/>{b} : {c}%"
            }
        }
    },
    _a[chart_1.Type.LiquidFill] = {},
    _a);
//# sourceMappingURL=chart.js.map